import styles from './breadcrumbs.module.css';
import RightChevron from '../../../img/icons/right-chevron.svg';
export default function Breadcrumbs () {
  return (
    <div className={styles.breadcrumbsContainer}>
      <div
        className='container'
        style={{ backgroundColor: '#f8f8f8', height: '48px' }}
      >
        <nav className={styles.linksContainer} aria-label='Breadcrumb'>
          <a href='/'>Home</a>
          <RightChevron style={{ marginTop: 0 }} />
          <a href='/acprr-tool/?step=0' aria-current='page'>
            Aged Care Provider Requirements Search
          </a>
        </nav>
      </div>
    </div>
  );
}
